module.exports = __webpack_public_path__ + "img/payment_icon_gpwebpay.58f89353.png";